import BootstrapUtil from '../bootstrap-util';
import ImageGalleryManager from '../js/image-gallery/image-gallery-manager';
import IncrementTable from '../js/increment-table/increment-table';
import AuctionDocument from '../js/auction-document/auction-document';
import { SHOW_INCREMENT_TABLE } from '../js/increment-table/increment-table-events';
import { EventService } from 'proxiponents';

const reactComponentMap = {
  ImageGalleryManager,
  IncrementTable,
  AuctionDocument,
};

window.wpReactApp = {
};

window.wpReactApp.showBidIncrementDialog = function() {
  EventService.dispatchEvent(SHOW_INCREMENT_TABLE);
};

window.wpReactApp.render = function(){
  BootstrapUtil.bootstrapEntrypoint(reactComponentMap);
};

window.wpReactApp.render();
